import { useEffect } from 'react';

export function useTimeoutEffect(callback, delay) {
    useEffect(() => {
        const timerId = setTimeout(() => {
            callback(); // runs once after delay
        }, delay);

        return () => clearTimeout(timerId);
    }, []); // empty dependency = run only once
}
